/* GarajMoto vehicle search library (window.GMV)
   Data: theme assets gm_meta.json, gm_m_<shard>.json, gm_cat_<slug>.json (built by build_index.py)
   Fitment names: fitment_index.json (Shopify Files). Saved scooter: localStorage "gm_scooter". */
(function () {
  'use strict';
  if (window.GMV) return;
  var FITMENT_URL = 'https://cdn.shopify.com/s/files/1/1056/4540/8581/files/fitment_index.json?v=1779266314';
  var RESULTS_URL = '/collections/piese-scuter';
  var cache = {};
  function metaUrl() { var el = document.querySelector('[data-gm-meta]'); return el ? el.getAttribute('data-gm-meta') : null; }
  function base() { var u = metaUrl() || ''; return u.split('?')[0].replace(/gm_meta\.json$/, ''); }
  function getJSON(url) {
    if (!cache[url]) cache[url] = fetch(url, { credentials: 'omit' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .catch(function (e) { delete cache[url]; throw e; });
    return cache[url];
  }
  var GMV = {
    RESULTS_URL: RESULTS_URL,
    meta: function () { return getJSON(metaUrl()); },
    fitment: function () {
      try { var c = sessionStorage.getItem('gm_fitment_cache_v1'); if (c) { var d = JSON.parse(c); cache.fit = Promise.resolve(d); } } catch (e) {}
      if (!cache.fit) cache.fit = getJSON(FITMENT_URL).then(function (d) { try { sessionStorage.setItem('gm_fitment_cache_v1', JSON.stringify(d)); } catch (e) {} return d; });
      return cache.fit;
    },
    model: function (mid) {
      return GMV.meta().then(function (m) { return getJSON(base() + 'gm_m_' + (parseInt(mid, 10) % m.nsh) + '.json?b=' + m.b); })
        .then(function (sh) { return sh[String(mid)] || {}; });
    },
    cat: function (slug) { return GMV.meta().then(function (m) { return getJSON(base() + 'gm_cat_' + slug + '.json?b=' + m.b); }); },
    saved: function () { try { return JSON.parse(localStorage.getItem('gm_scooter') || 'null'); } catch (e) { return null; } },
    save: function (brand, modelId, display) { try { localStorage.setItem('gm_scooter', JSON.stringify({ brand: brand, modelId: String(modelId), display: display })); } catch (e) {} },
    clear: function () { try { localStorage.removeItem('gm_scooter'); } catch (e) {} },
    url: function (mid, extra) {
      var u = RESULTS_URL + '?m=' + encodeURIComponent(mid);
      if (extra) Object.keys(extra).forEach(function (k) { if (extra[k]) u += '&' + k + '=' + encodeURIComponent(extra[k]); });
      return u;
    },
    norm: function (s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, ' ').trim(); },
    esc: function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); },
    money: function (v) { return Number(v).toFixed(2).replace('.', ',') + ' lei'; },
    img: function (p, w) { return p ? 'https://cdn.shopify.com/s/files/' + p + (p.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 360) : ''; },
    /* Flatten fitment index into a searchable model list (with part counts) */
    models: function () {
      if (cache.models) return cache.models;
      cache.models = Promise.all([GMV.fitment(), GMV.meta()]).then(function (r) {
        var d = r[0], meta = r[1], out = [];
        d.b.forEach(function (b) {
          (d.m[b] || []).forEach(function (m) {
            var n = meta.counts[m.id] || 0;
            if (!n) return;
            out.push({ id: m.id, brand: b, d: m.d, cc: m.cc, yf: m.yf, yt: m.yt, n: n, key: GMV.norm(b + ' ' + m.d) });
          });
        });
        return out;
      });
      return cache.models;
    },
    /* Token search: every query token must appear in "brand model". Ranked by prefix match then part count. */
    searchModels: function (list, q, brand, limit) {
      var toks = GMV.norm(q).split(' ').filter(Boolean);
      var res = list.filter(function (m) {
        if (brand && m.brand !== brand) return false;
        for (var i = 0; i < toks.length; i++) if (m.key.indexOf(toks[i]) === -1) return false;
        return true;
      });
      res.sort(function (a, b) { return (b.n - a.n) || a.key.localeCompare(b.key); });
      return res.slice(0, limit || 50);
    },
    modelMeta: function (m) {
      var y = (m.yf || m.yt) ? ((m.yf && m.yf < 1900 ? '' : (m.yf || '')) + '-' + (m.yt && m.yt > 2100 ? '' : (m.yt || ''))) : '';
      return [m.cc ? m.cc + 'cc' : '', y].filter(Boolean).join(' · ');
    },
    findModel: function (mid) {
      return GMV.models().then(function (list) { for (var i = 0; i < list.length; i++) if (list[i].id === String(mid)) return list[i]; return null; });
    }
  };
  window.GMV = GMV;
})();
